<template>
  <div :style="display">
    <!--    <div id="app" v-show="is_show">-->
    <div id="app">
      <!-- 浏览器原生播放器 -->
      <audio
        :src="song.audio_url"
        id="audio"
        controls
        style="display: none"
      ></audio>

      <!-- 音乐播放器 -->
      <div id="music-container" class="audioplayer">
        <div class="ap-status">
          <!-- 播放列表 -->
          <div class="ap-playlist" :class="{ 'ap-playlist-hide': !listShow }">
            <!-- 列表头部 -->
            <div class="ap-playlist-header">
              <div class="ap-playlist-header-name">
                <span class="ap-playlist-header-title">播放列表</span>
                <span class="ap-playlist-header-amount"
                  >({{ songList.length }})</span
                >
              </div>
              <div class="ap-playlist-header-close" @click="handleList">
                <img src="@/assets/img/icon_close1.png" alt />
              </div>
            </div>
            <!-- 列表内容 -->
            <div class="ap-playlist-body ps">
              <ol>
                <li
                  class="ap-playlist-line"
                  :class="{ 'ap-playlist-line-active': index == i }"
                  v-for="(li, i) in songList"
                  @click="choseSong(li, i)"
                  :key="li.id"
                  :data-index="i"
                >
                  <div class="ap-playlist-line-name">
                    {{ li.title }}-{{ li.album }}
                  </div>
                  <div class="ap-playlist-line-box">
                    <div class="ap-playlist-line-time">
                      <img src="@/assets/img/clock.png" alt />
                      <span>{{ li.audio_duration | timeToString }}</span>
                    </div>
                    <div class="ap-playlist-line-artist">
                      {{ li.display_time | timefilters }}
                    </div>
                  </div>
                </li>
              </ol>
            </div>
          </div>
          <!-- 控制器综合，包含控制器，音量，进度条等 -->
          <div class="ap-controller">
            <div class="ap-controller-left">
              <!-- 封面 -->
              <div class="ap-cover">
                <img :src="song.cover_url" alt />
              </div>
              <!-- 上一首 -->
              <el-button
                class="ap-button ap-skipback-button"
                @click="skipBack"
                :disabled="this.index == 0"
              >
                <img src="@/assets/img/icon_left.png" alt />
              </el-button>
              <!-- 播放与暂停 -->
              <div class="ap-button ap-play-button" @click="play">
                <!-- 暂停 -->
                <img src="@/assets/img/icon_open.png" alt v-if="!playing" />
                <!-- 播放 -->
                <img src="@/assets/img/icon_suspend.png" alt v-else />
              </div>
              <!-- 下一首 -->
              <el-button
                class="ap-button ap-skipforward-button"
                @click="skipForward"
                :disabled="this.index == this.songList.length - 1"
              >
                <img src="@/assets/img/icon_right.png" alt />
              </el-button>
            </div>
            <div class="ap-controller-center">
              <!-- 歌曲信息 -->
              <div class="ap-song-msg">
                <span class="ap-name">{{ song.title }}</span>
              </div>
              <!-- 进度条 -->
              <div class="ap-progress-line" ref="trackLine">
                <div class="ap-play-track" ref="track">
                  <!-- 总进度 -->
                  <div class="ap-play-bar-wrap">
                    <!-- 缓存进度 -->
                    <div
                      class="ap-buffer-bar"
                      :style="{ transform: 'scaleX(' + bufferedScaleX + ')' }"
                    ></div>
                    <!-- 当前进度 -->
                    <div
                      class="ap-progress-bar"
                      :class="{ 'forbid-transition': thumbSlide }"
                      :style="{ transform: 'scaleX(' + progressScaleX + ')' }"
                    ></div>
                  </div>
                  <!-- 进度按钮 -->
                  <div
                    class="ap-progress-thumb"
                    :class="{ 'forbid-transition': thumbSlide }"
                    ref="thumb"
                    :style="{
                      transform: 'translateX(' + thumbTranslateX + 'px)',
                    }"
                  >
                    <img src="@/assets/img/icon_progress.png" alt />
                  </div>
                </div>
                <span class="ap-time">
                  <span class="ap-current-time">{{ currentTime }}</span>
                  <span>/</span>
                  <span class="ap-total-time">{{ totalTime }}</span>
                </span>
              </div>
            </div>
            <div class="ap-controller-right">
              <!-- 下载 -->
              <!-- <div class="ap-button ap-downLoad-button" @click="downLoad">
                <div class="ap-downLoad-button-bg">
                  <img src="@/assets/img/icon_download.png" alt />
                </div>
              </div> -->
              <!-- 分享 -->
              <div class="ap-button ap-share-button" @click="share">
                <div class="ap-share-button-bg">
                  <img src="@/assets/img/icon_share.png" alt />
                </div>
                <div v-show="is_share" style="position: absolute; bottom: 51px">
                  <canvas id="canvas2"></canvas>
                </div>
              </div>
              <!-- 播放列表 -->
              <div class="ap-button ap-playlist-button" @click="handleList">
                <div class="ap-playlist-button-bg">
                  <img src="@/assets/img/icon_list.png" alt />
                </div>
              </div>

              <!-- 音量 -->
              <div class="ap-button ap-volume-button" @click="showVolume">
                <img src="@/assets/img/icon_volume.png" alt />
              </div>
              <!-- 音量进度条 -->
              <div
                class="ap-volume-line"
                :class="isShow == true ? 'isActive' : ''"
                ref="trackVLine"
              >
                <div class="ap-volume-track" ref="trackV">
                  <div class="ap-volume-bar-wrap">
                    <div
                      class="ap-volume-bar"
                      :class="{ 'forbid-transition': thumbVSlide }"
                      :style="{ transform: 'scaleX(' + volume + ')' }"
                    ></div>
                  </div>
                  <div
                    class="ap-volume-thumb"
                    ref="thumbV"
                    :class="{ 'forbid-transition': thumbVSlide }"
                    :style="{ transform: 'translateX(' + volumeX + 'px)' }"
                  >
                    <div class="ap-volume-thumb-dot"></div>
                  </div>
                </div>
              </div>
              <div
                @click="closeAudio"
                style="position: absolute; right: -12%; top: -14px"
              >
                <img
                  src="@/assets/img/icon_audio_close.png"
                  alt
                  srcset
                  style="width: 12px"
                />
              </div>
            </div>
          </div>
          <!-- 提示区 -->
          <div class="ap-toast" :class="{ 'ap-toast-hide': error.length <= 0 }">
            {{ error }}
          </div>
        </div>
      </div>
    </div>
    <div class="dialog">
      <!-- 音频订阅 -->
      <el-dialog
        :visible.sync="radioDialog"
        width="800px"
        :close-on-click-modal="false"
        class="singleDialog"
      >
        <div class="singleList">
          <div class="header">
            <div class="message">
              <div class="img" v-if="info">
                <img :src="info.avatar" alt />
              </div>
              <div>
                <p v-if="info">{{ info.nickname }}</p>
                <p>
                  账号
                  <span v-if="info">{{ info.login_name }}</span> ,
                  <template v-if="info.has_read_ability">您是Lite会员</template>
                  <template v-else>您还不是VIP会员</template>
                </p>
              </div>
            </div>
            <div class="close">
              <img src="@/assets/img/icon_close.png" @click="radioClose" alt />
            </div>
          </div>
          <div class="dialog-body">
            <h3>
              <span>购买套餐</span>
              <span v-if="isShow != 0" style="font-size: 16px; font-weight: 400"
                >| {{ memberTitle }}</span
              >
            </h3>
            <div class="body-message">
              <ul class="subsrcibe">
                <li
                  v-for="(item, i) in radioList"
                  :key="i"
                  @click="changeRadio(item, i)"
                  :class="i == pro_id ? 'showIcon' : ''"
                >
                  <div class="subsrcibe-box">
                    <div class="img" v-if="i == pro_id">
                      <img src="@/assets/img/icon_select.png" alt />
                    </div>
                    <div
                      class="limited"
                      v-if="
                        item.original_price != null &&
                        item.original_price > item.price
                      "
                    >
                      限时优惠
                    </div>
                    <p>{{ item.description }}</p>
                    <div class="message">
                      ￥
                      <span>{{ item.price }}</span>
                      /永久
                    </div>
                  </div>
                </li>
              </ul>
              <div class="buy-tips">
                <ul>
                  <li>· 购买后即可永久畅听本集音频</li>
                  <li>· 一财会员可免费畅听所有音频</li>
                </ul>
                <p @click="goSubscribe">订阅会员？</p>
              </div>
            </div>
            <div class="pay-method">
              <div class="method">
                <el-button
                  :class="select == 0 ? 'selectBtn' : ''"
                  @click="payRadioMethod(0)"
                >
                  <div class="icon">
                    <img src="@/assets/img/icon_wechart.png" alt />
                    <span>微信支付</span>
                  </div>
                </el-button>
                <el-button
                  :class="select == 0 ? '' : 'selectBtn'"
                  @click="payRadioMethod(1)"
                >
                  <div class="icon">
                    <img src="@/assets/img/icon_alipay.png" alt />
                    <span>支付宝支付</span>
                  </div>
                </el-button>
              </div>
              <div class="pay-message">
                <div class="wechart">
                  <div class="img" v-show="!showRet && select == 1" style="height: 153px;">
                    <iframe
                      style="
                        width: 140px;
                        margin-top: 10px;
                        margin-left: 4px;
                        border: none;
                      "
                      :src="wechat"
                    ></iframe>
                  </div>
                  <div class="img" v-show="!showRet && select == 0">
                    <canvas id="canvas"></canvas>
                  </div>
                  <div v-if="showBtn">
                    <p
                      @click="getWechat"
                      v-if="showRet"
                      style="cursor: pointer; margin-right: 40px"
                    >
                      {{ tip }}
                    </p>
                  </div>
                  <p v-else style="cursor: pointer; margin-right: 40px">
                    {{ code_ts }}
                  </p>
                </div>
                <div class="pay">
                  <p>
                    {{ price_type[select] }}扫码，支付
                    <span>{{ price }}</span> 元
                  </p>
                  <p>支付账号：{{ info.login_name }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- 弹框 -->
    <LoginDialog
      :loginDialogs="loginDialogs"
      @child-event="getParentEvent"
    ></LoginDialog>
  </div>
</template>
<script>
import {
  getAudioArticlesList,
  getAudioSeriesList,
  getAudioProduct,
  getAudioAtricleOrder,
  getAudioSerieOrder,
  getNotifyJs,
} from "@/api/radio";
import { downloadFile } from "@/utils/download";
import LoginDialog from "@/components/loginDialog";
import QRCode from "qrcode";
export default {
  components: {
    LoginDialog,
  },
  props: {
    is_playing: [String, Boolean, Number],
    member_btn: [String, Boolean, Number],
    audio_id: [String, Boolean, Number],
    audio_type_id: [String, Boolean, Number],
    audio_type: [String, Boolean, Number],
  },
  data() {
    return {
      display: "display: none",
      is_share: false,
      tip: "刷新二维码",
      showRet: true,
      wechat: "",
      pro_id: 0,
      price_type: ["微信", "支付宝"],
      price: 0,
      is_jurisdiction: false, // 是否有权限
      loginDialogs: false,
      radioDialog: false, // 音频订阅dialog
      radioList: [],
      select: 0, // 默认微信支付 true
      isSelect: true, // 默认微信支付 true
      isVipActive: 0,
      // 单集名称
      memberTitle: "等年终奖是不是跳槽的最大障碍",
      // 购买vip弹窗
      isVipShow: 0,
      // 用户信息
      info: {
        avatar: require("@/assets/img/code.png"),
        nickname: "李晓雅",
        login_name: "187****2726",
        // buyMoney: "18",
        wechart: require("@/assets/img/code.png"),
        yicai_user_id: 0,
      },
      // 会员订阅
      subscribeDialog: false,
      // 是否显示音频播放
      // is_show: false,
      aid: 0,
      atid: 0,
      at: "",
      free_duration: 0, // 播放状态
      playing: 0, // 播放状态
      index: 0, // 当前播放歌曲在列表中的下标
      id: 2, // 当前播放歌曲的id（此处貌似没有用到）
      currentTime: "00:00", // 当前播放时间
      totalTime: "00:00", // 总播放时间
      bufferedScaleX: 0, // 缓存进度
      progressScaleX: 0, // 播放进度
      thumbTranslateX: 0, // 进度条滑块位置
      volume: 1, // 音量进度
      volumeX: 0, // 音量滑块位置
      thumbSlide: false, // 进度条滑块滑动时标记
      thumbVSlide: false, // 音量滑块滑动时标记
      error: "", // 报错内容
      // playType: 1, // 播放类型：1-列表循环，2-随机播放，3-单曲循环
      listShow: false, // 播放列表是否展示
      isShow: false,
      isDisabled: false, // 禁用按钮上一首
      disabled: false, // 下一首
      song: {},
      songList: [],
      intervalId: null,
      at_serie_id: 0,
      track_width: 0,
      // 倒计时
      numRefresh: 0,
      showBtn: true,
      code_ts: "请5秒后重试",
      sec: 10,
    };
  },
  watch: {
    $route() {
      this.listShow = false;
      this.is_share = false;
      this.clearInt();
    },
    is_playing(newValue, oldValue) {
      if (newValue > 0) {
        this.playing = newValue;
        if (newValue && this.songList.length) {
          this.display = "";
          // 初始化音频的监听事件
          this.audioInit();
          audio.play();
          this.$emit("showPlayBtn", true);
        }
        if (!this.songList.length) {
          this.$message.error("暂无音频");
        }
      } else {
        this.playing = false;
        audio.pause();
        this.$emit("showPlayBtn", false);
      }
    },
    member_btn(newValue, oldValue) {
      if (newValue) {
        this.memberBtn();
      }
    },
    audio_id(newValue, oldValue) {
      this.songList = [];
      this.song = [];
      this.aid = newValue;
      this.atid = 0;
      this.at = "";
      this.playing = 0;
      let _this = this;
      if (_this.aid > 0) {
        // _this.is_show = true;
        var params = {
          article_id: _this.aid,
          equipment: "android",
        };
        getAudioArticlesList(params).then((res) => {
          var flag = 0;
          _this.songList = res.data.data[0].articles;
          _this.songList.forEach((value, index) => {
            if (value.id == _this.aid) {
              _this.song = value;
              _this.free_duration = value.free_duration;
              _this.is_jurisdiction = value.is_jurisdiction;
              flag = index;
            }
          });
          _this.index = flag;
          if (_this.index == 0) {
            _this.isDisabled = true;
          } else if (_this.index >= _this.songList.length - 1) {
            _this.disabled = true;
          }
          _this.getData();
          // audio的DOM结构获取需要在mounted中，在created中话会变成 <audio :src="song.url" id="audio" controls autoplay></audio>
          _this.setPageListen();
        });
      }
    },
    audio_type_id(newValue, oldValue) {
      this.songList = [];
      this.song = [];
      this.atid = newValue;
      this.aid = 0;
      this.at = "";
      this.playing = 0;
      let _this = this;
      if (_this.atid > 0) {
        // _this.is_show = true;
        var params = {
          id: _this.atid,
          equipment: "android",
        };
        getAudioSeriesList(params).then((res) => {
          _this.at_serie_id = res.data.data[0].id;
          _this.songList = res.data.data[0].articles;
          _this.song = _this.songList[0];
          _this.free_duration = _this.song.free_duration;
          _this.is_jurisdiction = _this.song.is_jurisdiction;
          _this.isDisabled = true;

          _this.getData();
          // audio的DOM结构获取需要在mounted中，在created中话会变成 <audio :src="song.url" id="audio" controls autoplay></audio>
          _this.setPageListen();
        });
      }
    },
    audio_type(newValue, oldValue) {
      this.songList = [];
      this.song = [];
      this.at = newValue;
      this.aid = 0;
      this.atid = 0;
      this.playing = 0;
      let _this = this;
      if (_this.at == "AudioNew") {
        // _this.is_show = true;
        var params = {
          type: _this.at,
          equipment: "android",
        };
        getAudioSeriesList(params).then((res) => {
          _this.at_serie_id = res.data.data[0].id;
          _this.songList = res.data.data[0].articles;
          _this.song = _this.songList[0];
          _this.free_duration = _this.song.free_duration;
          _this.is_jurisdiction = _this.song.is_jurisdiction;
          _this.isDisabled = true;

          _this.getData();
          // audio的DOM结构获取需要在mounted中，在created中话会变成 <audio :src="song.url" id="audio" controls autoplay></audio>
          _this.setPageListen();
        });
      }
    },
  },
  mounted() {
    let audio = document.getElementById("audio");
    this.getUserInfo();
    let _this = this;
    window.onscroll = function () {
      // 滚动条距离顶部的距离
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 可视区域的总高度
      var windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      // 滚动条的总高度
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      // if (scrollHeight - scrollTop - windowHeight <= 80) {
      //   if (_this.playing >= 0) {
      //     document.querySelector(".audioplayer").style.position = "initial";
      //   }
      // } else {
      //   document.querySelector(".audioplayer").style.position = "fixed";
      // }
    };
  },
  methods: {
    closeAudio() {
      this.playing = false;
      audio.pause();
      this.$emit("showPlayBtn", false);
      this.display = "display:none";
    },
    clearInt() {
      if (this.intervalId != null) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
    setWechat(src = "") {
      if (src != "") {
        if (this.select == 0) {
          var canvas = document.querySelector("#canvas");
          QRCode.toCanvas(canvas, src);
        } else {
          this.wechat = src;
        }
        this.showRet = false;
      } else {
        this.tip = "刷新二维码";
        this.showRet = true;
      }
    },
    getWechat() {
      if (this.numRefresh > 0) {
        var timer = setInterval(() => {
          this.sec = this.sec - 1;
          this.code_ts = this.sec + "s后重试";
          this.showBtn = false;
          if (this.sec === 0) {
            clearInterval(timer);
            this.sec = 10;
            this.code_ts = this.sec + "s后重试";
            this.showBtn = true;
            this.showRet = true;
          }
        }, 1000);

        this.numRefresh = 0;
      } else {
        if (this.select == 0) {
          var channel = "wx_wap";
        } else {
          var channel = "alipay_wap";
        }
        var params = {
          channel: channel,
          uid: this.info.yicai_user_id,
          yicai_platform: "pc",
          putType: "1",
          quantity: 1,
          product_id: this.radioList[this.pro_id].name,
          title: this.radioList[this.pro_id].description,
        };
        if (this.radioList[this.pro_id].product_type == "audio_article") {
          this.$set(params, "article_id", this.song.id);
          getAudioAtricleOrder(params).then((res) => {
            if (res.data.hasOwnProperty("error")) {
              this.tip = "已购买";
            } else if (res.data.data.ret == 200) {
              this.setWechat(res.data.data.data.code_url);
              this.notify = res.data.data.data;
              this.getNotify(res.data.data.order_no);
            }
          });
        } else {
          if (this.aid > 0) {
            this.$set(params, "audio_serie_id", this.song.audio_serie_id);
          } else {
            this.$set(params, "audio_serie_id", this.at_serie_id);
          }
          getAudioSerieOrder(params).then((res) => {
            if (res.data.hasOwnProperty("error")) {
              this.tip = "已购买";
            } else if (res.data.data.ret == 200) {
              this.setWechat(res.data.data.data.code_url);
              this.notify = res.data.data.data;
              this.getNotify(res.data.data.order_no);
            }
          });
        }

        this.numRefresh++;
      }
    },
    getNotify(id) {
      let _this = this;
      this.intervalId = setInterval(function () {
        if (_this.radioList[_this.pro_id].product_type == "audio_article") {
          var params = {
            audio_type: "AudioArticle",
          };
        } else {
          var params = {
            audio_type: "AudioSerie",
          };
        }
        getNotifyJs(params, id).then((res) => {
          if (res.data.data.status == "paid") {
            _this.$message.success("支付成功");
            setTimeout(function () {
              _this.clearInt();
              location.reload();
            }, 1000);
          }
        });
      }, 5000);
    },
    getProduct() {
      if (this.aid > 0) {
        var params = {
          type: "android",
          audio_type: "Article",
          id: this.song.id,
        };
      } else {
        var params = {
          type: "android",
          audio_type: "Audio",
          id: this.at_serie_id,
        };
      }
      getAudioProduct(params).then((res) => {
        this.radioList = res.data.data;
        this.price = this.radioList[0].price;
      });
    },
    getUserInfo() {
      if (
        localStorage.getItem("userInfo") != "" &&
        localStorage.getItem("userInfo") != null
      )
        this.info = JSON.parse(localStorage.getItem("userInfo"));
    },
    // 弹框
    getParentEvent(data) {
      this.loginDialogs = data;
    },
    // 关闭音频会员订阅弹框
    radioClose() {
      this.radioDialog = false;
      this.isVipShow = 0;
      this.tip = "刷新二维码";
      this.select = 0;
    },
    changeRadio(scope, flag) {
      this.pro_id = flag;
      this.price = scope.price;
      this.setWechat();
    },
    // 关闭弹框
    subscribeClose() {
      this.subscribeDialog = false;
      this.isActive = 0;
      this.isSelect = true;
    },
    // 会员订阅
    goSubscribe() {
      this.isVipShow = 0;
      this.radioDialog = false;
      this.subscribeDialog = true;
      this.select = true;
      this.resetSetItem("isActive", 0);
      this.$router.push({
        path: "/member",
      });
    },
    payRadioMethod(tag) {
      this.select = tag;
      this.setWechat();
    },
    // 会员弹框
    memberBtn() {
      if (
        localStorage.getItem("Authorization") != "" &&
        localStorage.getItem("Authorization") != null
      ) {
        this.getUserInfo();
        if (this.is_jurisdiction == true) {
          // 是会员
        } else {
          // 非会员
          this.radioDialog = true;
          // this.radioList = [];
          // this.getProduct("Audio");
          this.getProduct();
        }
      } else {
        this.loginDialogs = true;
      }
    },

    // 获取数据，并放入当前播放列表
    getData() {
      // 初始化进度条与音量的鼠标滑动事件
      this.slideProgress();
      this.slideVolume();
    },

    // 暂停与播放
    play() {
      if (this.playing) {
        // 播放中,点击则为暂停
        this.playing = false;
        audio.pause();
        this.$emit("showPlayBtn", false);
      } else {
        // 暂停中,点击则为播放
        this.playing = true;
        audio.play();
        this.$emit("showPlayBtn", true);
      }
    },

    // 音频事件初始化
    audioInit() {
      let _this = this;
      this.display = "";
      // 音频或视频文件已经就绪可以开始，在点击播放时触发
      audio.addEventListener("play", () => {});
      // 浏览器开始寻找指定的音频或视频
      audio.addEventListener("loadstart", () => {
        // 当前音量进度
        _this.volume = audio.volume;
        // _this.volumeX = _this.volume * _this.$refs.trackV.offsetWidth;
        _this.volumeX = document.getElementsByClassName(
          "ap-volume-track"
        )[0].offsetWidth;
      });

      // 播放位置改变时触发[注意:播放和调整指示定位时都会触发]（主要事件）
      audio.addEventListener("timeupdate", () => {
        if (!_this.is_jurisdiction && audio.currentTime > _this.free_duration) {
          this.playing = false;
          audio.pause();
          _this.$emit("showPlayBtn", false);
          _this.memberBtn();
        }
        // 当前播放时间
        _this.currentTime = _this.timeToString(audio.currentTime);
        // 总播放时间
        _this.totalTime = _this.timeToString(audio.duration);

        // 当前播放进度百分比
        let precent = audio.currentTime / audio.duration || 0;

        // 当前播放进度
        _this.progressScaleX = precent.toFixed(3);

        // 当前缓存进度
        // 已缓存时间
        let buffered = audio.buffered.length
          ? audio.buffered.end(audio.buffered.length - 1)
          : 0;
        _this.bufferedScaleX = (buffered / audio.duration).toFixed(3);

        let progressL = document.getElementsByClassName("ap-play-track")[0]
          .offsetWidth;
        // 当前进度按钮位置
        _this.thumbTranslateX = (precent * progressL).toFixed(3);

        // 当前音量进度
        _this.volume = audio.volume;
        // _this.volumeX = _this.volume * _this.$refs.trackV.offsetWidth;
        _this.volumeX =
          _this.volume *
          document.getElementsByClassName("ap-volume-track")[0].offsetWidth;
      });

      // 音频或视频能够不停顿地一直播放
      audio.addEventListener("canplaythrough", () => {});

      // 音频或视频的时长已改变
      audio.addEventListener("durationchange", () => {
        _this.totalTime = _this.timeToString(audio.duration);
      });

      // 在音频或视频终止加载时触发，包括终止当前播放（未加载完）进行下一首播放时也会触发
      audio.addEventListener("abort", () => {});

      // 在音频或视频加载发生错误时触发
      audio.addEventListener("error", () => {
        switch (audio.networkState) {
          case "0":
            _this.error = "尚未初始化";
            break;
          case "1":
            _this.error = "正在下载数据";
            break;
          case "3":
            _this.error = "未找到资源";
            break;
        }
        audio.readyState == "0" && (_this.error = "音频地址错误");

        setTimeout(() => {
          _this.error = "";
        }, 3000);
      });

      // 播放结束
      audio.addEventListener(
        "ended",
        () => {
          _this.playing = false;
          this.$emit("showPlayBtn", false);
        },
        true
      );
    },

    // 滑动进度条
    slideProgress() {
      // this.slideFn('progress', this.$refs.thumb, this.$refs.track.offsetWidth)

      this.slideClickFn();
    },

    // 滑动音量
    slideVolume() {
      // this.slideFn("volume", this.$refs.thumbV, this.$refs.trackV.offsetWidth);
      this.slideVClickFn();
    },
    showVolume() {
      this.isShow = !this.isShow;
    },

    // 上一首
    skipBack() {
      this.skipFn("skipBack");
    },

    // 下一首
    skipForward() {
      this.skipFn("skipForward");
    },
    // 解决页面切换到后台或者切换到其他页面一段时间后，切回时出现进度条回弹的bug
    // 想看此bug的可以不调用该方法，并在播放之后切换到其他页面一段时间后切回，会发现进度条出现回弹的bug，因为transition的问题
    setPageListen() {
      let _this = this;
      // js判断浏览当前页（关键词：当前，浏览）
      // 可以通过document.hidden属性判断当前页面是否是激活状态。
      // 兼容性：IE10+，Firefox10+,Chrome14+,Opera12.1+,Safari7.1+
      var hiddenProperty =
        "hidden" in document
          ? "hidden"
          : "webkitHidden" in document
          ? "webkitHidden"
          : "mozHidden" in document
          ? "mozHidden"
          : null;
      var visibilityChangeEvent = hiddenProperty.replace(
        /hidden/i,
        "visibilitychange"
      );
      var onVisibilityChange = function () {
        if (!document[hiddenProperty]) {
          _this.thumbSlide = true;
          setTimeout(() => {
            _this.thumbSlide = false;
          }, 300);
        } else {
        }
      };
      document.addEventListener(visibilityChangeEvent, onVisibilityChange);
    },

    // 是否显示播放列表
    handleList() {
      this.listShow = !this.listShow;
    },

    // 列表选歌
    choseSong(li, i) {
      this.song = li;
      this.index = i;
      this.playing = true;
      this.free_duration = li.free_duration;
      this.is_jurisdiction = li.is_jurisdiction;
      setTimeout(() => {
        audio.play();
        this.$emit("showPlayBtn", true);
      }, 100);
    },
    // 下载
    downLoad() {
      if (this.song.is_jurisdiction) {
        let url = this.song.audio_url;
        let name = this.song.title + ".mp3";
        this.$message({
          message: "已添加到下载队列中！",
          type: "success",
        });
        downloadFile(url, name);
      } else {
        this.memberBtn();
      }
    },
    // 分享
    share() {
      this.share_show();
      this.is_share = !this.is_share;
    },
    share_show() {
      var src = this.song.share_url;
      var canvas2 = document.querySelector("#canvas2");
      QRCode.toCanvas(canvas2, src);
    },
    // 上下首封装
    skipFn(type) {
      switch (this.playType) {
        case 2: // 随机播放
          this.index = Math.floor(Math.random() * this.songList.length);
          break;
        default:
          if (type == "skipBack") {
            this.index - 1 >= 0 ? this.index-- : 0;
          } else {
            this.index =
              this.index + 1 >= this.songList.length
                ? this.songList.length - 1
                : this.index + 1;
          }
          break;
      }
      this.song = this.songList[this.index];
      this.playing = true;
      this.free_duration = this.song.free_duration;
      setTimeout(() => {
        this.totalTime = "00:00";
        audio.play();
        this.$emit("showPlayBtn", true);
      }, 100);
    },
    // 滑动封装
    slideFn(type, thumbDom, progressLength) {
      let thumb = thumbDom;
      let _this = this;
      thumb.onmousedown = function (e) {
        // 移动时暂停播放并设置transition: none，解决在滑动结束后出现回弹的bug
        if (type == "progress") {
          audio.pause();
          _this.$emit("showPlayBtn", false);
          _this.thumbSlide = true;
        } else {
          _this.thumbVSlide = true;
        }

        let progressL = progressLength;
        let mouseInitX = e.clientX,
          mouseEndX = 0,
          moveX = 0,
          thumbInitX = _this.stringToNum(thumb.style.transform),
          thumbEndX = 0;

        document.onmousedown = function (e) {
          mouseEndX = e.clientX;
          moveX = mouseEndX - mouseInitX;

          let a = thumbInitX - 0 + moveX;
          if (moveX > 0) {
            thumbEndX = a > progressL ? progressL : a;
          } else {
            thumbEndX = a <= 0 ? 0 : a;
          }

          if (type == "progress") {
            _this.progressScaleX = thumbEndX / progressL;
            _this.thumbTranslateX = thumbEndX;
          } else {
            _this.volume = thumbEndX / progressL;
            _this.volumeX = thumbEndX;
          }
        };

        document.onmouseup = function (e) {
          if (type == "progress") {
            audio.currentTime = (thumbEndX * audio.duration) / progressL;
            audio.play();
            _this.$emit("showPlayBtn", true);
            _this.thumbSlide = false;
          } else {
            audio.volume = thumbEndX / progressL;
            _this.thumbVSlide = false;
          }

          document.onmousedown = null;
          document.onmousemove = null;
          document.onmouseup = null;
        };
      };
    },

    // 点击封装
    slideClickFn() {
      let thumb = this.$refs.trackLine;
      let _this = this;
      thumb.onclick = function (e) {
        audio.pause();
        // 距离初始位置X
        let layerX = e.layerX;
        // 总长度
        var totalX = document.getElementsByClassName("ap-play-track")[0]
          .offsetWidth;
        if (layerX >= totalX) {
          layerX = totalX;
          audio.currentTime = (layerX * audio.duration) / totalX - 1;
        } else {
          audio.currentTime = (layerX * audio.duration) / totalX;
        }

        // 当前进度按钮位置
        _this.thumbTranslateX = layerX.toFixed(3);

        if (!_this.is_jurisdiction && audio.currentTime > _this.free_duration) {
          _this.playing = false;
          audio.currentTime = _this.free_duration;
          _this.memberBtn();
        } else {
          setTimeout(function () {
            _this.playing = true;
            audio.play();
            _this.$emit("showPlayBtn", true);
          }, 800);
        }
      };
    },

    // 点击封装
    slideVClickFn() {
      let thumb = this.$refs.trackVLine;
      let _this = this;
      thumb.onclick = function (e) {
        // 距离初始位置X
        let layerX = e.offsetX;
        // // 总长度
        var totalX = document.getElementsByClassName("ap-volume-track")[0]
          .offsetWidth;
        if (layerX > totalX) {
          layerX = totalX;
        }
        audio.volume = layerX / totalX;
        _this.volume = audio.volume;
        _this.volumeX = _this.volume * totalX;
      };
    },
    // 字符串转数字
    stringToNum(str) {
      return Number(str.replace(/translateX\(|px\)/g, ""));
    },
    // 秒值转字符串
    timeToString(param) {
      param = parseInt(param);
      let hh = "",
        mm = "",
        ss = "";
      if (param >= 0 && param < 60) {
        param < 10 ? (ss = "0" + param) : (ss = param);
        return "00:" + ss;
      } else if (param >= 60 && param < 3600) {
        mm = parseInt(param / 60);
        mm < 10 ? (mm = "0" + mm) : mm;
        param - parseInt(mm * 60) < 10
          ? (ss = "0" + String(param - parseInt(mm * 60)))
          : (ss = param - parseInt(mm * 60));
        return mm + ":" + ss;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
/*控制器综合*/
.audioplayer {
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  white-space: nowrap;
  background-color: #313131;
  color: #ffffff;
  font-size: 14px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  z-index: 104;
  position: fixed;
  bottom: 0;
}
.audioplayer .ap-status {
  position: relative;
  width: 72%;
  margin: 0 auto;
}
.audioplayer .ap-controller {
  display: flex;
  width: 100%;
  height: 100%;
  background-color: #313131;
  position: relative;
  padding: 4px 30px;
}
.audioplayer .ap-button {
  cursor: pointer;
  transition: 0.2s;
}
.audioplayer .ap-controller .ap-controller-left > *,
.audioplayer .ap-controller .ap-controller-right > * {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  vertical-align: middle;
}
svg:not(:root) {
  overflow: hidden;
}
.audioplayer svg:not(.ap-svg-exclude) {
  width: 28px;
  height: 28px;
  vertical-align: middle;
  transition: 0.2s;
}
.audioplayer .ap-progress-thumb svg {
  width: 21px;
  height: 19px;
  display: block;
  cursor: pointer;
}
.audioplayer .ap-controller .ap-controller-center .ap-buffer-bar,
.audioplayer .ap-controller .ap-controller-center .ap-progress-bar {
  position: absolute;
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  transition: transform 0.5s linear, -webkit-transform 0.5s linear;
}

/*left*/
.audioplayer .ap-controller-left .el-button {
  background: none;
  border: none;
}
.ap-controller-left .is-disabled {
  span {
    img {
      opacity: 0.5;
    }
  }
}
.audioplayer .ap-controller-left .ap-cover {
  background: #fff;
  -webkit-background-size: 100% 100%;
  background-size: 100% 100%;
  cursor: pointer;
  width: 40px;
  height: 40px;
  overflow: hidden;
  img {
    width: 100%;
    padding: 2px;
    border: 2px solid #656565;
  }
}
.audioplayer .ap-controller-left .ap-button {
  padding: 0 8px;
}
.audioplayer .ap-controller-left .ap-skipback-button {
  margin-left: 16px;
}
.audioplayer .ap-controller-left .ap-skipforward-button {
  margin-right: 16px;
}

/*center*/
.audioplayer .ap-controller-center {
  padding: 10px 0;
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: hidden;
}
.audioplayer .ap-controller-center .ap-song-msg {
  display: flex;
  flex: 1;
  align-items: center;
}
.audioplayer .ap-controller-center .ap-song-msg .ap-name {
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
}
.audioplayer .ap-controller-center .ap-song-msg .ap-artist {
  font-size: 12px;
  margin-left: 6px;
  cursor: default;
  white-space: nowrap;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
}
.audioplayer .ap-controller-center .ap-time {
  font-size: 12px;
  flex: 1;
  text-align: right;
  cursor: default;
  /*min-width: 110px;*/
  margin-left: 20px;
}
.audioplayer .ap-controller-center .ap-song-msg .ap-time .ap-current-time {
  color: #fff;
}
.audioplayer .ap-controller-center .ap-progress-line {
  flex: 1;
  display: flex;
  align-items: center;
}
.audioplayer .ap-controller-center .ap-play-track {
  position: relative;
  width: 100%;
  height: 3px;
}
.audioplayer .ap-controller-center .ap-play-bar-wrap {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  border-radius: 1.5px;
  overflow: hidden;
  background: #909090;
}
.audioplayer .ap-controller-center .ap-buffer-bar {
  background: rgba(50, 176, 218, 0.47);
}
.audioplayer .ap-controller-center .ap-progress-bar {
  background: #32b0da;
}
.audioplayer .ap-controller .ap-controller-center .ap-progress-thumb {
  transition: -webkit-transform 0.5s linear;
  transition: transform 0.5s linear;
  transition: transform 0.5s linear, -webkit-transform 0.5s linear;
  position: absolute;
  top: -8px;
  left: 0px;
}

/*right*/
.audioplayer .ap-controller-right {
  width: 360px;
  padding: 0 20px;
  margin-top: 10px;
}
.audioplayer .ap-controller-right .ap-button {
  padding: 0 8px;
}
.audioplayer .ap-controller-right .ap-volume-line {
  width: 86px;
  margin-right: 8px;
  opacity: 0;
}
.isActive {
  opacity: 1 !important;
}
.audioplayer .ap-controller-right .ap-volume-track {
  position: relative;
  width: 100%;
  height: 3px;
}
.audioplayer .ap-controller-right .ap-volume-bar-wrap {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 1.5px;
  overflow: hidden;
  background: #909090;
}
.audioplayer .ap-controller-right .ap-volume-bar {
  position: absolute;
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #32b0da;
}
.audioplayer .ap-controller-right .ap-volume-thumb {
  position: absolute;
  top: -4px;
  left: -6px;
  cursor: pointer;
}
.audioplayer .ap-controller-right .ap-volume-thumb-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #32b0da;
  -webkit-transform: scale(0);
  transform: scale(0);
  transition: 0.2s;
}
.audioplayer .ap-controller-right .ap-volume-line:hover .ap-volume-thumb-dot {
  transform: scale(1);
}

/*提示区*/
.audioplayer .ap-toast {
  position: absolute;
  bottom: 72px;
  left: 50%;
  -webkit-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
  padding: 10px 20px;
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 4px;
  color: #fff;
  opacity: 1;
  pointer-events: none;
  transition: 0.3s;
}
.audioplayer .ap-toast-hide {
  opacity: 0;
  -webkit-transform: translate(-50%, 12px);
  transform: translate(-50%, 12px);
}
/*播放列表*/
.ps {
  overflow-y: scroll;
  overflow-anchor: none;
  -ms-overflow-style: none;
  touch-action: auto;
  -ms-touch-action: auto;
}
// 修改滚动条样式
.ps::-webkit-scrollbar-track {
  background-color: #191919;
}
.ps::-webkit-scrollbar {
  width: 20px;
}
.ps::-webkit-scrollbar-thumb {
  border-radius: 50%;
}

ol {
  padding: 0;
  margin: 0;
}

.audioplayer .ap-playlist {
  width: 100%;
  position: absolute;
  right: 0;
  bottom: 56px;
  background-color: #191919;
  transition: 0.3s;
  -webkit-transform-origin: 0 100%;
  transform-origin: 0 100%;
  color: #fff;
  opacity: 0.9;
}
.audioplayer .ap-playlist.ap-playlist-hide {
  display: none;
}
.audioplayer .ap-playlist .ap-playlist-header {
  padding: 16px 20px 16px 20px;
  display: flex;
  cursor: default;
  border-bottom: 1px solid #474747;
  font-size: 16px;
}
.audioplayer .ap-playlist .ap-playlist-header .ap-playlist-header-name {
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.audioplayer .ap-playlist-header .ap-playlist-header-close {
  font-size: 14px;
  width: 16px;
  height: 16px;
  margin-left: 20px;
}
.audioplayer .ap-playlist .ap-playlist-body {
  position: relative;
  background-color: #191919;
  height: 260px;
}
.audioplayer .ap-playlist .ap-playlist-line {
  display: flex;
  cursor: default;
  justify-content: space-between;
  list-style: lower-roman;
  .ap-playlist-line-box {
    display: flex;
    width: 40%;
    justify-content: space-between;
    color: #999999;
    img {
      vertical-align: middle;
      margin-right: 4px;
    }
    span {
      vertical-align: middle;
    }
  }
  .ap-playlist-line-name {
    font-size: 16px;
  }
}
.audioplayer .ap-playlist .ap-playlist-line:hover {
  color: #0091ff;
}
.audioplayer .ap-playlist .ap-playlist-body li {
  padding: 10px 0px 10px 20px;
  transition: 0.2s;
  cursor: pointer;
  line-height: 21px;
}
.singleDialog {
  >>> .el-dialog__header {
    display: none;
  }
  >>> .el-dialog__body {
    padding: 0;
    margin-top: 5px;
  }
  .singleList {
    .header {
      display: flex;
      justify-content: space-between;
      background: url("../assets/img/bg_single.png") no-repeat;
      padding: 20px 20px 20px 30px;
      background-size: auto;
      .message {
        display: flex;
        .img {
          width: 70px;
          height: 70px;
          margin-right: 20px;
          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }
        div {
          p {
            font-size: 20px;
            color: #9a6416;
            margin-top: 6px;
          }
          p:last-child {
            font-size: 14px;
            span {
              color: #ff0000;
            }
          }
        }
      }
    }
    .dialog-body {
      padding: 6px 30px 30px 30px;
      h3 {
        color: #dfb349;
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 40px;
      }
      h4 {
        color: #dfb349;
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 40px;
        span {
          vertical-align: middle;
          display: inline-block;
        }
        img {
          vertical-align: middle;
          display: inline-block;
        }
      }
      .body-message {
        display: flex;
        align-items: center;
        .subsrcibe {
          display: contents;
          width: 100%;
          li {
            width: 30.5%;
            border: 1px solid #eeeeee;
            position: relative;
            margin-right: 30px;
            cursor: pointer;
            .subsrcibe-box {
              width: 100%;
              text-align: center;
              padding: 10px;
              font-size: 16px;
              .img {
                img {
                  position: absolute;
                  left: 10px;
                  top: 10px;
                }
              }
              .limited {
                position: absolute;
                background: #ff0000;
                padding: 5px 12px;
                border-radius: 0 10px 0 10px;
                right: -2px;
                top: -17px;
                color: #fff;
                font-size: 14px;
              }
              p {
                line-height: 36px;
                margin-top: 20px;
              }
              .message {
                color: #dfb349;
                font-size: 18px;
                margin-bottom: 10px;
                span {
                  font-size: 30px;
                  font-weight: 600;
                  margin-left: -9px;
                }
              }
            }
          }
          .showIcon {
            border: 2px solid #dfb349;
            background: #fcf7e6;
          }
        }
        .other {
          display: flex;
          justify-content: space-between;
          li {
            margin-right: 0;
          }
        }
        .buy-tips {
          font-size: 14px;
          ul {
            li {
              margin-bottom: 20px;
            }
          }
          p {
            padding-bottom: 10px;
            text-decoration: underline;
            color: #0091ff;
            cursor: pointer;
          }
        }
      }
      .pay-method {
        border: 1px solid #eeeeee;
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        .method {
          display: flex;
          flex-direction: column;
          margin-right: 40px;
          .el-button {
            border: 1px solid #eeeeee;
            background: #f5f5f5;
            text-align: center;
            line-height: 100px;
            border: none;
            margin-left: 0;
            border-radius: 0;
            font-size: 16px;
            padding: 0 40px;
            .icon {
              img {
                vertical-align: middle;
                margin-right: 4px;
              }
            }
          }
          .selectBtn {
            background: #fff;
            border-right: 0;
          }
          .isActive {
            background: #fff;
            border-right: 0;
          }
          >>> .el-button:hover,
          .el-button:active,
          .el-button:focus {
            color: #333 !important;
          }
        }
        .pay-message {
          display: flex;
          align-items: center;
          margin-right: 16px;
          .wechart {
            text-align: center;
            color: #999999;
            margin-right: 30px;
            .img {
              // max-width: 130px;
              padding: 10px;
              border: 1px solid #eeeeee;
              margin-bottom: 6px;
              img {
                width: 100%;
              }
              >>> #canvas {
                width: 136px;
                height: 136px;
              }
            }
          }
          .pay {
            font-size: 16px;
            p {
              line-height: 38px;
              span {
                color: #dfb349;
                font-size: 30px;
                font-weight: bold;
              }
            }
            p:last-child {
              color: #999999;
            }
          }
        }
      }
    }
  }
}
.ap-share-button {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/audio.vue